import { Icon } from "@chakra-ui/icons";
import { Box, Center, HStack, VStack } from "@chakra-ui/layout";
import React, { useEffect } from "react";
import { usePageContext } from "../../../contexts/page.context";
import { Progress } from "../../../components/progress";
import { Text } from "../../../components/text";
import UploadIcon from "../../../components/Upload.icon";
import SECTIONS from "../../actions/data/sectionTitle";
import CloseIcon from "../icons/Close.icon";
import useWalletStore from "../../../store";
import InitialStep from "./InitialStep";
import MethodDetails from "./MethodDetails";
import MethodInput from "./MethodInput";
import SavedBank from "./saved/SavedBank";
import SavedCrypto from "./saved/SavedCrypto";
import useSendFundsStore from "../store";
import { useThemeColors } from "../../../../../hooks/useThemeColors";

const SendFunds = () => {
  const { lightMode } = usePageContext();
  const inputSource = useWalletStore((s) => s.inputSource);
  const currentSection = useWalletStore((s) => s.section);
  const closeSection = useWalletStore((s) => s.closeSection);
  const page = useSendFundsStore((s) => s.page);
  const pageNumber = useSendFundsStore((s) => s.pageNumber);
  const isBankMethod = useSendFundsStore((s) => s.isBankMethod);
  const isCryptoMethod = useSendFundsStore((s) => s.isCryptoMethod);
  const showBankAddresses = useSendFundsStore((s) => s.showBankAddresses);
  const showCryptoAddresses = useSendFundsStore((s) => s.showCryptoAddresses);
  const resetPage = useSendFundsStore((s) => s.resetPage);

  const { PRIMARY_COLOR, SECONDARY_COLOR, SECONDARY_COLOR_DARK } = useThemeColors();

  useEffect(() => {
    return () => {
      resetPage();
      inputSource();
    };
  }, []);

  return currentSection === SECTIONS[2] ? (
    <VStack
      border={`1px solid ${lightMode ? "#e1e1e1" : "#343C40"}`}
      borderRadius={"20px"}
      w={"100%"}
      px={"39px"}
      gap={0}
      py={"28px"}
    >
      <HStack width={"100%"} alignItems={"flex-start"} gap={"24px"}>
        <Center
          borderRadius={"50%"}
          w={"60px"}
          h={"60px"}
          backgroundColor={lightMode ? SECONDARY_COLOR : SECONDARY_COLOR_DARK}
        >
          <Icon width={"24px"} height={"24px"} as={UploadIcon} />
        </Center>
        <VStack flexGrow={1} gap={0}>
          <HStack w={"100%"} justifyContent={"space-between"}>
            <Text fontSize={"14px"} fontWeight={"700"}>
              Send Funds
            </Text>

            {/* {page === 0 && (
              <HStack
                bg={lightMode ? "#E5F1F7" : "#01293E"}
                color={lightMode ? "#000" : "#fff"}
                px={"16px"}
                py={"10px"}
                borderRadius={"10px"}
              >
                <Text lineHeight={"14px"} fontSize={"14px"}>
                  Note trades need to be closed before the transfer can be made
                </Text>
              </HStack>
            )} */}

            <HStack gap={"23px"}>
              <HStack gap={"13px"}>
                <Progress
                  value={
                    isBankMethod() || isCryptoMethod()
                      ? pageNumber / 4
                      : pageNumber / 3
                  }
                />
                <Text
                  fontSize={"14px"}
                  color={pageNumber === 3 ? PRIMARY_COLOR : "#7f7f7f"}
                >
                  {pageNumber}/{isBankMethod() || isCryptoMethod() ? 4 : 3}
                </Text>
              </HStack>
              <Box
                cursor={"pointer"}
                onClick={() => {
                  resetPage();
                  inputSource("");
                  closeSection();
                }}
              >
                <CloseIcon />
              </Box>
            </HStack>
          </HStack>
          {showBankAddresses || showCryptoAddresses ? (
            <></>
          ) : (
            <>
              {page === 0 && <InitialStep />}
              {page === 1 && <MethodInput />}
              {(page === 2 || page === 3) && (
                <MethodDetails onClose={closeSection} />
              )}
            </>
          )}
        </VStack>
      </HStack>
      {showBankAddresses && <SavedBank />}
      {showCryptoAddresses && <SavedCrypto />}
    </VStack>
  ) : null;
};

export default SendFunds;
